import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { BASE_ROUTES } from '@core/routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from 'oneok/environments/environment';
import { auth as authInterceptor } from '@customer/auth.interceptor';

export const customerPortalConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.googleRecaptcha.siteKey
    },
    provideRouter(
      BASE_ROUTES,
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always'
      })
    ),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAngularSvgIcon()
  ]
};
